export default __webpack_public_path__ + "static/media/micro_calendar.fff1bd69.svg";